<div class='sidebar-width'>
  <div class="p-4">
    <div class="p-2">
      <img src="assets/TIC-Logo-For-Dark-BG.png" width="100%" />
    </div>
  </div>
  <!-- <div class="d-flex sidebar-btn align-content-center" (click)="openCleanBookingDialog()">
    <span class="flex-fill fas pl-2 fa-plus" style="width: 33%;"></span>
    <div class="flex-fill text-left" style="width: 66%;">
      New Booking
    </div>
  </div> -->
  <div *ngFor="let item of sidebarService.sidebarItems">
    <!-- Amv04 -->
    <!-- <div class="d-flex sidebar-btn align-content-center" [routerLink]="[item.link]"
      routerLinkActive="sidebar-btn-active" *ngIf="item.allowed"> -->
    <div class="d-flex sidebar-btn align-content-center" [routerLink]="[item.link]"
      routerLinkActive="sidebar-btn-active" *ngIf="item.allowed && !item.isGroup" [routerLinkActiveOptions]="{ exact: true }">
    <!-- Amv04 end -->
      <span class="flex-fill fas pl-2" [ngClass]="item.icon" style="width: 33%;"></span>
      <div class="flex-fill text-left" style="width: 66%;">
        {{item.name}}
      </div>
    </div>

    <!-- Amv04 -->
    <div class="d-flex groupsidebar-btn align-content-center" *ngIf="item.allowed && item.isGroup" (click)="item.expanded = !item.expanded">
      <span class="flex-fill fas pl-2" [ngClass]="item.icon" style="width: 33%;"></span>
      <div class="flex-fill text-left" style="width: 66%;">
        {{item.name}}
      </div>
      <span class="flex-fill fas pl-2 fa-angle-right fa-solid" *ngIf="item.isGroup && !item.expanded"></span>
      <span class="flex-fill fas pl-2 fa-angle-down fa-solid" *ngIf="item.isGroup && item.expanded"></span>
    </div>

    <div class="pl-4" *ngIf="item.expanded">
      <div
        *ngFor="let child of getAllowedChildren(item.children)"
        class="d-flex sidebar-btn align-content-center"
        [routerLink]="[child.link]"
        routerLinkActive="sidebar-btn-active"
      >
        <span class="flex-fill fas pl-2" [ngClass]="child.icon" style="width: 33%;"></span>
        <div class="flex-fill text-left" style="width: 66%;">
          {{child.name}}
        </div>
      </div>
    </div>
    <!-- Amv04 end -->

  </div>
  <div class="d-flex sidebar-btn align-content-center" (click)="logout()">
    <span class="flex-fill fas pl-2 fa-sign-out-alt" style="width: 33%;"></span>
    <div class="flex-fill text-left" style="width: 66%;">
      Logout
    </div>
  </div>
</div>